(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview-selector/assets/javascripts/coupon-overview-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview-selector/assets/javascripts/coupon-overview-selector.js');
"use strict";

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const CouponOverviewRows = svs.components.tipsen.couponOverviewRows.CouponOverviewRows;
const useCouponContext = svs.components.tipsen.couponComponents.useCouponContext;
const CouponOverviewSingleRows = svs.components.tipsen.couponOverviewSingleRows.CouponOverviewSingleRows;
const CouponOverviewExternal = svs.components.tipsen.couponOverviewExternal.CouponOverviewExternal;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectIsCouponSingleRows = _svs$components$tipse.selectIsCouponSingleRows,
  selectIsCouponExternal = _svs$components$tipse.selectIsCouponExternal;
const clx = svs.components.lbUtils.clx;
const CouponOverview1X2 = _ref => {
  let children = _ref.children,
    classNames = _ref.classNames;
  if (!children) {
    return null;
  }
  return React.createElement("div", {
    className: classNames
  }, children);
};
const CouponOverviewSelector = _ref2 => {
  let _ref2$isCompact = _ref2.isCompact,
    isCompact = _ref2$isCompact === void 0 ? false : _ref2$isCompact,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const isSingleRows = useSelector(state => selectIsCouponSingleRows(state, couponId));
  const isExternal = useSelector(state => selectIsCouponExternal(state, couponId));
  const blockName = 'pg_coupon_overview_selector';
  const classNames = clx(blockName, "".concat(blockName, "--show-all"), {
    'margin-xs-h-2': !isCompact
  });
  if (isCompact && isExternal) {
    return React.createElement(CouponOverview1X2, {
      classNames: classNames
    }, React.createElement(CouponOverviewExternal, null));
  } else if (isCompact && isSingleRows) {
    return React.createElement(CouponOverview1X2, {
      classNames: classNames
    }, React.createElement(CouponOverviewSingleRows, {
      style: style
    }));
  }
  return React.createElement(CouponOverview1X2, {
    classNames: classNames
  }, React.createElement(CouponOverviewRows, {
    style: style
  }));
};
setGlobal('svs.components.tipsen.couponOverviewSelector.CouponOverviewSelector', CouponOverviewSelector);

 })(window);